import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { getBaseUrl } from '@/utils/config'
import { Message,Loading } from 'element-ui';
import utils from '@/utils/common'
// create an axios instance
var loading ={
  close:function(){
    
  }
},reqNum = 0;
const service = axios.create({
  //baseURL: "http://localhost:64452/", // url = base url + request url
  baseURL:getBaseUrl(),
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if(config.url.indexOf('//')> -1){
      config.baseURL = "";
    }
    if(config.url !="api/heartlog" && config.url != "api/task/gettaskbystuid"){
		loading = Loading.service({
		  lock: true,
		  text: 'loding...',
		  background: 'rgba(0, 0, 0, 0)'
    });
  }
    reqNum++;
    let userinfo = utils.storageGet("userinfo") ||{};
    config.headers['userid'] = userinfo.userid;
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    reqNum--;
    if (reqNum <= 0) {
      reqNum = 0;
      loading.close();
    };
 
    const res = response.data;
    if(response.config.url.indexOf('//') > -1){
      return res;
    }
    // 是心跳包接口,由错误直接弹窗
    if(response.config.url == "api/heartlog"){

      if(res.state !== 0){

        let ischaoshi = utils.sessionGet("chaoshi");
        if(ischaoshi == 1){

        }else{   //此处应该显示有样式的弹窗；
           
          Vue.prototype.$heartbeat({title:'提示',content:res.msg});

          utils.sessionSet("chaoshi",1);
          //清理用户缓存数据
          utils.storageClear();
        }
      }

      return res.data;

    }

    if (res.state !== 0) {
      if(response.config.url .indexOf('api/getjifen') == -1){
        Message({
          showClose: true,
          message:res.msg,
          type:'error'
        });
      }
      
      return Promise.reject(res.msg)
    } else {
			
      return res.data
    };
  },
  error => {
    //console.log('err' + error) // for debug
    reqNum = 0;
    loading.close();
    if(response.config.url .indexOf('api/getjifen') == -1){
      Message({
        showClose: true,
        message:res.msg,
        type:'error'
      });
    }
    return Promise.reject(error)
  }
)

export default service
